import React from 'react';
import PropTypes from 'prop-types';
import { Headline3 } from '@cdm/quickenloans-library/lib';

import ReadingTime from '../ReadingTime';
import Linker from '../../../Atoms/Link';
import FeaturedImage from '../../../Atoms/FeaturedImage';

import {
    container,
    imageContainer,
    cardBody,
    cardContent,
    cardFooter,
    gridCardAParent,
} from './GridCard.module.scss';
import { testAttributes } from '../Constants';

const getCardContent = (title, minutes, id) => (
    <>
        <div className={cardContent}>
            <Headline3 testId={`${testAttributes.CARD_TITLE}${id}`}>
                {title}
            </Headline3>
        </div>
        <div className={cardFooter}>
            <ReadingTime
                minutes={minutes}
                testId={`${testAttributes.CARD_READING_TIME}${id}`}
            />
        </div>
    </>
);

const GridCard = ({
    featuredImage = null,
    imgPath = '',
    title,
    isPinned = false,
    minutes = 0,
    href,
    id,
    imgAlt = '',
}) => (
    <div
        className={`noMargin ${gridCardAParent} ${container} ${isPinned ? 'pinned-post' : ''}`}
        data-testid={`${testAttributes.POST_GRID_CARD}${id}`}
        itemScope
        itemType="https://schema.org/Article"
    >
        <Linker href={href}>
            {(featuredImage || imgPath) && (
                <div className={imageContainer}>
                    <FeaturedImage
                        gatsbyFeaturedImage={featuredImage}
                        imgPath={imgPath}
                        imgAlt={imgAlt}
                        testId={`${testAttributes.CARD_THUMBNAIL}${id}`}
                    />
                </div>
            )}

            <div className={cardBody}>{getCardContent(title, minutes, id)}</div>
        </Linker>
    </div>
);

GridCard.propTypes = {
    /** Image; Set WP object for any image would you like to test */
    featuredImage: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
    /** Title; Set title of the card */
    title: PropTypes.string.isRequired,
    /** Title; Set title of the card */
    imgAlt: PropTypes.string,
    /** Link - URL of post */
    href: PropTypes.string.isRequired,
    /** Pinned - Set the post pinned or not */
    isPinned: PropTypes.bool,
    /** Reading time in minutes */
    minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /** id for card id and use in testid */
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    /** Image; Set URL for any image would you like to test */
    imgPath: PropTypes.string,
};

export default GridCard;
